import { instance as AXIOS } from "../axios";

import axios from "axios";
import qs from "qs";
import convert from "xml-js";

// initial state
const state = {
    data: []
}

// getters
const getters = {
    getAll: (state) => {
        return state.data;
    },
    getContasByCodigo: (state) => (str) => {
        return new Promise((resolve, reject) => {
            if (state.data.length > 0 && str) resolve(state.data.filter((el) => { return el.codigoconta === String(str) }))
            else resolve([])
        })
    },
    getFirstLastContas: (state) => {
        if(state.data.length==0) return null
        else if(state.data.length==1) return state.data[0]
        else return {first: state.data[0].codigoconta, last: state.data[state.data.length-1].codigoconta}
    }
}

// actions
const actions = {

    get({ commit }, params) {

        var url = params.url;

        const options = {
            method: 'POST',
            headers: {
                'content-type': 'application/x-www-form-urlencoded'
            },
            data: qs.stringify({
                invocationPassword: params.pwd,
                cliente: params.cliente,
                ano: params.ano,
            }),
            url
        };

        return axios(options).then((res) => {
            try {
                commit('setData', convert.xml2json(res.data, { compact: true, spaces: 4 }))
            } catch (error) {
                commit('setData', null)
            }
        }).catch((err) => {
            commit('setData', null)
        })
    },

    generatePdfRazao({commit}, data) {
        return AXIOS
            .post('/pdf/razao', {
                data: data
            })
            .then(res => {
                return !res.errors;
            })
            .catch(err => {
                return false;
            });
    },

    generatePdfAnalitico({commit}, data) {
        return AXIOS
            .post('/pdf/analitico', {
                data: data
            })
            .then(res => {
                return !res.errors;
            })
            .catch(err => {
                return false;
            });
    },

    generatePdfExtrato({commit}, data) {
        return AXIOS
            .post('/pdf/extrato', {
                data: data
            })
            .then(res => {
                return !res.errors;
            })
            .catch(err => {
                return false;
            });
    },

    generatePdfExtratoAll({commit}, data) {
        return AXIOS
            .post('/pdf/extratoAll', {
                data: data
            })
            .then(res => {
                return !res.errors;
            })
            .catch(err => {
                return false;
            });
    },

    clearData({ commit }) {
        return new Promise(async (resolve, reject) => {
            await commit('setData', null);
            resolve(true);
        });
    }

}

// mutations
const mutations = {
    setData(state, data) {
        state.data = data ? JSON.parse(JSON.parse(data).string._text) : [];
    }
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/contas.js